export const MAP_COLORS = [
  '#ecf4fe',
  '#daeafe',
  '#c7e0fe',
  '#b5d5fe',
  '#a3cbfe',
  '#90c1fe',
  '#4798fe',
  '#4798fe',
  '#4798fe',
  '#4798fe',
  '#4798fe'
];
